import AdminListModel from '@/models/AdminListModel';

export default {
  listById: (state: any, getters: any) => (listId: number) => {
    const list = state.lists[listId];
    if (list) {
      return new AdminListModel(list, getters);
    }
  },
};
